import React from 'react';

import PropTypes from 'prop-types';

import { getSalesStatusContent } from '../../utils/status';
import classNames from 'classnames';
import rebrandStyles from './Status.rebranding.module.scss';

const Header = ({ children, className }) => (
    <div
        className={className}
        data-automation="checkout-widget-status-page-header"
        aria-live="assertive"
        tabIndex="0"
    >
        {children}
    </div>
);

export default class Status extends React.PureComponent {
    static propTypes = {
        statusType: PropTypes.string.isRequired,
        toCheckout: PropTypes.func.isRequired,
        toPickASeat: PropTypes.func,
        toReservedTicketConfirmation: PropTypes.func,
        toTicketSelection: PropTypes.func.isRequired,
        toDeliveryMethod: PropTypes.func,
        toLogin: PropTypes.func,
        toInterstitial: PropTypes.func,
        closeModal: PropTypes.func,
        toTicketSelectionFromInterstitial: PropTypes.func,
        isNativeApp: PropTypes.bool,
    };

    render() {
        const {
            closeModalActions,
            toTicketSelectionFromInterstitial,
            closeModalOnNativeActions,
            eventSalesStatus,
            isAppRebrandActive,
            isNativeApp,
            statusType,
            toCheckout,
            toDeliveryMethod,
            toInterstitial,
            toLogin,
            toPickASeat,
            toReservedTicketConfirmation,
            toTicketSelection,
        } = this.props;

        const styles = isAppRebrandActive ? rebrandStyles : {};

        const closeModal = isNativeApp
            ? closeModalOnNativeActions
            : closeModalActions;

        const { headerText, children } = getSalesStatusContent(
            statusType,
            eventSalesStatus,
            {
                toCheckout,
                toPickASeat,
                toReservedTicketConfirmation,
                toDeliveryMethod,
                toLogin,
                toInterstitial,
                toTicketSelection,
                closeModal,
                toTicketSelectionFromInterstitial,
            },
            isAppRebrandActive,
        );

        const headerClassName = classNames(
            'eds-l-pad-top-2 eds-text--center',
            { 'eds-text-hs eds-text-color--grey-800': !isAppRebrandActive },
            styles?.header,
        );

        const childrenWrapperClassName = classNames(
            'eds-text-bm eds-text--center',
            {
                'eds-l-pad-vert-3': !isAppRebrandActive,
                'eds-l-pad-vert-4': isAppRebrandActive,
                'eds-text-color--grey-600': !isAppRebrandActive,
            },
            styles?.childrenWrapper,
        );

        return (
            <div
                className="eds-g-cell eds-g-cell-1-1"
                data-spec={`checkout-widget-status-page-${statusType}`}
                data-testid={`checkout-widget-status-page-${statusType}`}
            >
                <Header className={headerClassName}>{headerText}</Header>
                <div
                    className={childrenWrapperClassName}
                    data-testid="children-wrapper"
                >
                    {children}
                </div>
            </div>
        );
    }
}
